// extracted by mini-css-extract-plugin
module.exports = {"companyImageList":"company-images_component_companyImageList__osdeB"};